import "./style.css";

const Loading = (props) => {
	return (
		// <div className="loading text-center h-100 m-5 spinner absolute">
		<div className="flex justify-center items-center w-full spinner">
			<div>
				<span className="spinner-grow spinner-grow-sm text-color me-2" role="status"></span>
				<span className="text-color">{props.mensagem}</span>
			</div>
		</div>
	);
};

export default Loading;
